<div *ngIf="value" class="grid grid-cols-10">
  <div class="col-span-3  font-normal text-gray-400">{{key}}</div>
  <div class="col-span-7 font-medium ">{{value}}</div>
</div>